import { type FC } from "react";
import { useParams } from "react-router-dom";

import { cx } from "@emotion/css";
import { Section } from "@snapchat/snap-design-system";

import dancingRaccoonGif from "@app-assets/gif/dancing-raccoon.gif";

import { BUSINESS_MANAGER_URL } from "../../shared/constants";
import { linkButtonDefaultClassName, sectionContainer } from "../../shared/styles";
import { type AbsoluteRoute, type RouteParams } from "../routes/absoluteRoutes";

import { WelcomeNote, WelcomeParagraph, WelcomeTitle, spacingTop } from "./Welcome.styles";
import {
    BusinessManagerLinkText,
    DocsLinkText,
    GetStartedText,
    MembershipNote,
    WelcomeText,
} from "./messages.generated";

export const Welcome: FC = () => {
    const { orgId } = useParams<RouteParams[AbsoluteRoute.WELCOME_ORG]>();

    return (
        <Section className={sectionContainer}>
            <img alt="Colorful dancing cartoon raccoon with pool tube around belly" src={dancingRaccoonGif} />
            <WelcomeTitle>
                <WelcomeText />
            </WelcomeTitle>
            <WelcomeParagraph>
                <GetStartedText />
            </WelcomeParagraph>
            <a
                href="https://developers.snap.com/lens-studio/overview/building-your-first-lens/built-in-ar-effects"
                target="_blank"
                rel="noreferrer"
                className={cx(linkButtonDefaultClassName, spacingTop)}
            >
                <DocsLinkText />
            </a>
            {orgId && (
                <WelcomeNote>
                    <MembershipNote
                        link={
                            <a href={`${BUSINESS_MANAGER_URL}/${orgId}`} target="_blank" rel="noreferrer">
                                <BusinessManagerLinkText />
                            </a>
                        }
                    />
                </WelcomeNote>
            )}
        </Section>
    );
};
